<template>
  <div id="news-page-container" class="user-info-page" v-if="!isLoading">
    <c-banner-news />
    <c-news-content />
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import cBannerNews from '../../components/news/NewsBanner.vue'
import cNewsContent from '../../components/news/NewsContent.vue'

export default {
  name: 'News',
  components: {
    cBannerNews,
    cNewsContent
  },
  mounted () {
    const hasVisitedBefore = localStorage.getItem('hasVisitedBefore')

    if (!hasVisitedBefore) {
      this.actionPreloader(true)

      localStorage.setItem('hasVisitedBefore', 'true')

      setTimeout(() => {
        this.actionPreloader(false)
      }, 2000)
    }
  },
  computed: {
    ...mapState({
      isLoading: state => state.preloader.isLoading
    })
  },
  methods: {
    ...mapActions(['actionPreloader'])
  }
}
</script>
<style lang="scss" scoped>
#news-page-container {
  padding-top: 96px;
}
</style>
